/**
 * @generated SignedSource<<7b967d4d83ecfe7e998f72d0edf9bece>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AppAuthAPIConnectionSectionDeleteApiKeyMutation$variables = {
  apiKeyId: string;
};
export type AppAuthAPIConnectionSectionDeleteApiKeyMutation$data = {
  readonly deleteApiKey: {
    readonly app: {
      readonly apiKeys: ReadonlyArray<{
        readonly id: string;
      }>;
    };
  };
};
export type AppAuthAPIConnectionSectionDeleteApiKeyMutation = {
  response: AppAuthAPIConnectionSectionDeleteApiKeyMutation$data;
  variables: AppAuthAPIConnectionSectionDeleteApiKeyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "apiKeyId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "apiKeyId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "Apikey",
  "kind": "LinkedField",
  "name": "apiKeys",
  "plural": true,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AppAuthAPIConnectionSectionDeleteApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Apikey",
        "kind": "LinkedField",
        "name": "deleteApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "MutationRoot",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AppAuthAPIConnectionSectionDeleteApiKeyMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Apikey",
        "kind": "LinkedField",
        "name": "deleteApiKey",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "App",
            "kind": "LinkedField",
            "name": "app",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ab66014a9b4ab501eacfbe16e9b4e708",
    "id": null,
    "metadata": {},
    "name": "AppAuthAPIConnectionSectionDeleteApiKeyMutation",
    "operationKind": "mutation",
    "text": "mutation AppAuthAPIConnectionSectionDeleteApiKeyMutation(\n  $apiKeyId: ID!\n) {\n  deleteApiKey(id: $apiKeyId) {\n    app {\n      apiKeys {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ecb88079a8e0257fb9b663960a7693eb";

export default node;
